import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
let eventBus = null
const _ = require('lodash')
import * as TencentServer from "../api/tencent";
import * as GlobalServer from "../api/global";
import * as ResultServer from "../api/result";
import * as LoginServer from "../api/login";
import { postMessage } from "../utils/messageEvent";
//import { MessageBox } from 'element-ui';
import {
  //isNull,
  curSelectedNode,
  putObject,
  deleteObject,
  getFirstMenu,
  addIdByArr
} from "../utils/utils";
import Config from "../config/app";

export const setEventBus = _=>{eventBus = _}

export default new Vuex.Store({
  state: {
    dev:Config.isDev?1:0,//是否为测试版，0为否；
    isTopWindow:1,//是否在于IFRAME中，默认不存在
    operationSteps: [], // 操作步骤，用来匹配切换菜单流程
    addEmptyConfig: {type: 'animeEditModel', theme:{background:{url:'', type: 'image'}}},
    curForms: [], // 当前选中课件列表
    token: '',
    pptWarn: '只支持pptx类型文件，pptx文件命名只支持数字字母文字或组合', // 导入ppt提示语
    log: '', // 调试日志
    cocos_local: "", // cocos本地地址(调试使用)
    isBuildCocos: true,
    pptData: [], // 导入ppt历史记录
    isPPTUploading: false, // ppt正在导入中
    isPPTUploadRate: false, // 当前导入ppt百分比
    pptUnZipConfig: [], // ppt解码后配置
    curPPTRate: 0, // 当前ppt导入的比例(实时)
    userInfo: {}, // 用户信息 - 公共
    userInfoTwo: {}, // 用户信息 - 校区
    GlobalEvent: null, // 全局事件监听
    permissions: {}, // 当前权限
    platPermissions: {}, // 公共权限
    tencent: null, // 腾讯云配置 - 上传空间(校区)
    tencentPlatform: null, // 腾讯云配置配置 - 上传空间(公共)
    school: [], // 校区列表
    initConfig: {
      school_id: "", // 校区id
      id: "" // 课件id
    }, // 初始化参数
    // 导航配置
    menusData: {
      scenes_stage_id: "",
      scenes_state_shop: false,
      blocksForm: null,
      blocksSelected: '',
      lessonSelected: '',
      lessonSelectedConfig: {}
    },
    menusKeyBoard:false,//菜单课件操作
    menusDataIds: {}, // 配置表unique映射
    urlMap: [], // 涉及到的资源列表
    curClassType: "online", // 当前选中课件类型 online线上课件｜offline线下课件｜double_teacher双师课件
    saving: false, // 是否正在保存中
    initial: true, // 是否初始化
    editGameConfig: null, // 游戏配置
    addGameTempObj: {}, // 添加游戏配置
    updateLock: false, // 为更新复件加链接锁，默认不开启
    updateState:"已全部保存至云端",// 提示更新状态
    notice:{ico:"",state:false,info:"您的网络连接超时，数据已保存本地，需等待网络恢复后继续编辑"},// 是否离线状态

    timestamp: 0, // 与cocos临时约定权量值
    cocos_global_common: null, // cocos游戏全局表单配置数据

    is_global_select_menu: false, // 当前全局选中菜单
    global_select_unique: "", // 选中菜单
    tempInsertPPTConfig: null, // 临时需要插入ppt位置的配置信息

    sendKeyBoardToCocos: {}, // 发键盘事件给cocos前判断
    // 题库历史选中学科
    questionBankConfig: {
      subject_id: '',
      grade_id: ''
    },
    curCocosDevUrl: '', // 当前cocos开发地址
    timeFn: null, // 队列计时器
    operationQueue: [], // 消息队列 - 游戏编辑与cocos交互

    theme: '', // 当前主题
    otherToken: {
      theme: '',
      token: '',
      client_id: '',
      school_id: '',
      schoolDomain: '',
      loginOut: ''
    },
    isCocosSaving: false, // 当前cocos是否正在保存
    waitBackgourndVideo: false, // 等待刷新课件缩略图背景视频状态
    mulSelect: null, // 课件多选 []为多选状态 null为取消多选
    guideStep: 'initial', // 引导页步骤 start开始 first第一 second第二 ... done完成

    isCloseUser:false, // 教学平台是否已经唤醒禁用弹窗
    
    isYunkedun: true, // 是否云课盾平台
    brandName: '', // 登录页面品牌名称
    logoUrl: '', // 登录页面logo
    cacheList:{},
    vipInfo:{},//会员数据信息；
  },
  getters: {
    getCocosType(state){
      return state.menusData?.lessonSelectedConfig?.type
    },
    curTheme (state) {
      return state.theme === 'school-center'
    },
    cocosSaving(state){
      return state.isCocosSaving
    },
    allow2CocosKeboard(state){
      let status = true
      for(let item in state.sendKeyBoardToCocos){
        if(state.sendKeyBoardToCocos[item] === false) {
          status = false
        }
      }
      return status
    },
    // 获取当前选中校区的所有参数
    getShoolConfig(state) {
      let obj = {};
      try {
        state.school.map(v => {
          if (`${v.id}` === `${state.initConfig.school_id}`) {
            obj = v;
          }
        });
      } catch (e) {
        console.log("获取校区配置失败==>", e);
      }
      return obj;
    },
    isPlat(state) {
      return state.initConfig.school_id === "-1";
    },
    // 当前选中是否是PPT
    curIsPPT(state, getters){
      let newState = false;
      try {
        const warn = '对不起，该功能无法与PPT功能，兼容使用。'

        const time = new Date().getTime()
        __log__.push({type: 'curIsPPT',time})

        console.log('优化速度==>curIsPPT', time, getters.getCocosType)

        const node = getters.getCocosType // || getObjByCurLesson({});
        newState = (node === "html") ? warn : false;
      } catch (e) {
        console.log("等待获取当前是否是游戏==>", e);
      }
      return newState;
    },
    // 当前选中是否是游戏
    curIsGame(state, getters) {
      let newState = false;
      try {
        const warn = '游戏环节不支持该操作'

        const time = new Date().getTime()
        __log__.push({type: 'curIsGame',time})

        //console.log('优化速度==>curIsGame', time, getters.getCocosType)

        //console.time('[耗时]获取当前课件时间')
        const node = getters.getCocosType // || getObjByCurLesson({});
        //console.timeEnd('[耗时]获取当前课件时间')
        newState = (node === "game") ? warn : false;
      } catch (e) {
        console.log("等待获取当前是否是游戏==>", e);
      }
      return newState;
    },
    // 当前用户信息
    curUserInfo(state, getters) {
      return getters.isPlat ? state.userInfoTwo : state.userInfo;
    },
    //缓存的列表数据
    cacheList(state){
      return state.cacheList;
    },
    //是否为试用会员，默认为否
    vipInfo(state){
      return state.vipInfo;
    }
  },
  mutations: {
    setBlocksSelected(state, data) {
      if(state.menusData) {
        state.menusData.blocksSelected = data
      }
    },
    setKeyBoard(state){
      state.menusKeyBoard=state;
    },
    setOtherToken (state, data) {
      state.otherToken = data
      state.initConfig.school_id = data.school_id
    },
    initTencent(state, data) {
      state.tencent = { ...data };
    },
    initTencentPlatform(state, data) {
      state.tencentPlatform = { ...data };
    },
    initUserInfo(state, data) {
      state.userInfo = data;
    },
    initUserInfoTwo(state, data) {
      state.userInfoTwo = data;
    },
    initSchool(state, data) {
      state.school = data;
    },
    setInitConfig(state, data) {
      state.initConfig = { ...state.initConfig, ...data };
    },
    setUrlMap(state, data) {
      let status = true;
      let newArr = state.urlMap || [];
      newArr.map(v => {
        if (v.url === data.url && v.id === data.id && v.type === data.type)
          status = false;
      });
      if (status) {
        newArr.push(data);
        state.urlMap = newArr;
      }
    },
    setNewUrlMap(state, data) {
      state.urlMap = data;
    },
    setMenusData(state, data) {
      let newData = data;

      // 兼容模版旧数据 将数组转成字符串
      try {
        // 旧数据是数组
        if (Array.isArray(newData)) {
          // 旧数据只有一级导航, scene换成name | lesson换成children
          let blocksForm = addIdByArr({ parentNode: null, data: newData });
          blocksForm.map(v => {
            v.name = v.scene;
            v.children = v.lesson;
          });
          newData = {
            blocksForm
          };

          // 给旧数据加一个默认选中菜单
          const blocksSelected = getFirstMenu({ data: newData.blocksForm });
          if (blocksSelected) newData.blocksSelected = blocksSelected;
        }
        // 旧数据是对象，但是没有唯一标识和id
        else if (
          newData.blocksForm &&
          newData.blocksForm[0] &&
          !newData.blocksForm[0].unique
        ) {
          newData.blocksForm = addIdByArr({
            parentNode: null,
            data: newData.blocksForm
          });
          newData.blocksSelected = getFirstMenu({ data: newData.blocksForm });
        }
        // 旧数据菜单未选中情况
        else if (
          newData.blocksForm &&
          newData.blocksForm[0] &&
          `${newData.blocksSelected}` === `0`
        ) {
          newData.blocksForm = addIdByArr({
            parentNode: null,
            data: newData.blocksForm
          });
          newData.blocksSelected = getFirstMenu({ data: newData.blocksForm });
        }
      } catch (e) {
        console.log("兼容模版旧数据失败==>", e);
      }

      state.menusData = {
        blocksSelected: state.menusData.blocksSelected,
        lessonSelected: state.menusData.lessonSelected,
        ...newData
      };
    },
    addOneMenuData(state, data) {
      state.menusData = data;
    },
    setSaving(state, data) {
      state.saving = data;
    },
    setDev(state, data) {
      state.dev = data;
    },
    setUpdateState(state, value) {
      state.updateState = value;
    },
    setNotice(state, data) {
      state.notice = data;
    },
    setIsBuilding(state, data) {
      state.isBuildCocos = data;
    },
    initPermissions(state, value) {
      state.permissions = value;
    },
    initPlatPermissions(state, value) {
      state.platPermissions = value;
    },
    setGameConfig(state, value) {
      state.editGameConfig = null;
      state.editGameConfig = value;
    },
    setCurClassType(state, value) {
      state.curClassType = value;
    },
    cancelSelectMenu(state) {
      state.is_global_select_menu = false;
      state.global_select_unique = "";
    },
    setGlobalSselectUnique(state, value) {
      state.global_select_unique = value;
    },
    setPPTData(state, value) {
      state.pptData = value;
    },
    setTempInsertPPTConfig(state, value) {
      state.tempInsertPPTConfig = value;
    },
    setSendKeyBoardToCocos(state, {key, value}) {
      state.sendKeyBoardToCocos[key] = value
      state.sendKeyBoardToCocos = JSON.parse(JSON.stringify(state.sendKeyBoardToCocos))
    },
    setQuestionBankConfig(state, params){
      state.questionBankConfig =  {
        ...state.questionBankConfig,
        ...params
      }
    },
    setOperationQueue(state, list){
      state.operationQueue = state.operationQueue.concat(list)
      // 1.每300毫秒且事件池有数据 执行一次通知cocos
      let newArr = _.cloneDeepWith(state.operationQueue)
      let len = newArr.length
      let fn = ()=>{
          if(len>0) {
              let arr = []
              for (let i = 0; i < len; i++) {
                  arr.push(newArr.shift())
              }
              state.operationQueue = newArr
              postMessage({
                  type: 'EditGameConfig', value: {
                      timestamp: state.timestamp,
                      operationQueue: arr
                  }
              })
          }
      }
      const tFn = ()=> {
        clearTimeout(state.timeFn)
        state.timeFn = setTimeout(() => {
          fn && fn()
          if (state.operationQueue.length) tFn()
        }, 100)
      }
      tFn()
    },
    changeBrandName (state, obj) {
      const ico = document.getElementById('ico')
      if (obj) {
        state.isYunkedun = false
        state.brandName = obj.brand_name || '云课盾'
        state.logoUrl = obj.full_logo_url
        document.title = state.brandName + '课件编辑器'
        ico.href = state.logoUrl
      } else {
        state.isYunkedun = true
        state.brandName = '云课盾'
        state.logoUrl = ''
        ico.href = './favicon.ico'
        document.title = state.brandName + '课件编辑器'
      }
    },
    setVipInfo(state, data) {
      state.vipInfo = data;
    },
  },
  actions: {
    setBlocksSelected ({ commit }, value) {
      commit('setBlocksSelected', value)
    },
    setOtherToken ({ commit }, obj) {
      commit('setOtherToken', obj)
    },
    initTencent({ commit, state, dispatch }) {
      return TencentServer.getTXToken({
        clientsId: state.initConfig.school_id
      }).then(async config => {
        const newConfig = config;
        // 如果失效时间戳存在，则重新设置为一天后过期
        // if (newConfig.resource_token && newConfig.resource_token.expiredTime) newConfig.resource_token.expiredTime = getNextDay()
        commit("initTencent", newConfig);
        
        // token 失效后自动获取
        const time = newConfig.resource_token.expiredTime - newConfig.server_time;
        const fn = setTimeout(() => {
          dispatch("initTencent");
          clearTimeout(fn);
        }, time * 1000);
      });
    },
    initTencentPlatform({ commit, dispatch }) {
      return TencentServer.getTXToken({ clientsId: 0 }).then(async config => {
        const newConfig = config;
        // 如果失效时间戳存在，则重新设置为一天后过期
        // if (newConfig.resource_token && newConfig.resource_token.expiredTime) newConfig.resource_token.expiredTime = getNextDay()
        commit("initTencentPlatform", newConfig);

        /**
        console.log("newConfig",newConfig);
        if(isNull(newConfig)){
          MessageBox.$alert('数据异常，请刷新浏览器', '提示', {
            confirmButtonText: '确定',
            callback: {
              window.location.reload();
            }
          });
        } */

        // token 失效后自动获取
        const time = newConfig.resource_token.expiredTime - newConfig.server_time;
        const fn = setTimeout(() => {
          dispatch("initTencentPlatform");
          clearTimeout(fn);
        }, time * 1000);
      });
    },
    initUserInfoTwo({ commit }, obj) {
      commit("initUserInfoTwo", obj);
    },
    // 初始化学校列表，并设置当前学校或公共权限
    async initSchool({ state, commit, getters }) {
      const data1 = await GlobalServer.getSchool();

      // 获取用户信息 -- 公共
      const res = await LoginServer.getUserInfo();
      const obj = {};
      res.admin_permissions.forEach(v => {
        obj[v] = true;
      });
      let newRes = res;
      if (res.admin) newRes = { ...res, ...res.admin };
      commit("initUserInfoTwo", newRes);
      commit("initPlatPermissions", obj);

      commit("initSchool", data1.school);


      let data = null;
      if (`${state.initConfig.school_id}` !== "0") {
        let http = "https";
        if (Config.isDev) {
          http = "http";
        }
        let domain = getters.getShoolConfig.domain
        // 教学平台 则拿otherToken 中的 schoolDomain
        if (getters.curTheme) {
          domain = state.otherToken.schoolDomain
        }
        if (domain && domain.length>3) {
          console.log('domain==>2', domain)
          data = await GlobalServer.getPermissions({
            url: http + "://" + domain + "/api/user"
          });
          commit("initUserInfo", data);
          data = data.school_role_permission_ids;
        }
      }
      const newObj = {};
      data &&
        data.route_names.map(v => {
          if (`${v}`.indexOf("management_courseware") > -1 && v.slice(22)) {
            newObj[v.slice(22)] = true;
          }
        });
      commit("initPermissions", newObj);

      // clearTimeout(fn)
      return true;
    },
    async setInitConfig({ commit, state, dispatch }, config) {
      commit("setInitConfig", config);
      setTimeout(() => {
        `${state.initConfig.school_id}` !== "-1" && dispatch("initTencent");
        dispatch("initTencentPlatform");
      }, 300);

      // 获取用户信息 -- 公共
      const res = await LoginServer.getUserInfo();
      commit("initUserInfoTwo", res);

      const obj = {};
      res.admin_permissions.forEach(v => {
        obj[v] = true;
      });
      commit("initPlatPermissions", obj);

      dispatch('changeBrandName', state.initConfig.school_id)
      if(!state.initConfig.is_template)dispatch('setVipInfo', state.initConfig.school_id)

      // let data = null;
      // if (`${state.initConfig.school_id}` !== "0") {
      //   let http = "https";
      //   if (Config.isDev) {
      //     http = "http";
      //   }
      //   let domain = getters.getShoolConfig.domain
      //   // 教学平台 则拿otherToken 中的 schoolDomain
      //   if (getters.curTheme) {
      //     domain = state.otherToken.schoolDomain
      //   }
      //   if (domain && domain.length>3) {
      //     console.log('domain==>2', domain)
      //     data = await GlobalServer.getPermissions({
      //       url: http + "://" + domain + "/api/user"
      //     });
      //     commit("initUserInfoTwo", data);
      //     data = data.school_role_permission_ids;
      //   }
      // }
      // const newObj = {};
      // data &&
      //   data.route_names.map(v => {
      //     if (`${v}`.indexOf("management_courseware") > -1 && v.slice(22)) {
      //       newObj[v.slice(22)] = true;
      //     }
      //   });
      // commit("initPermissions", newObj);
    },
    setUrlMap({ commit }, item) {
      commit("setUrlMap", item);
    },
    setNewUrlMap({ commit }, data) {
      commit("setNewUrlMap", data);
    },
    setMenusData({ commit }, data) {
      commit("setMenusData", data);
    },
    // 给当前选中课程下添加一个空课程
    addOneMenuData({ state }, data2) {
      // 1.获取当前选中目录
      // 2.判断目录内是否有数据 无则新增一个数组 有的话找下当前选中的索引
      // 3.变更当前选中unique, 向cocos发送最新配置
      console.log(
        "添加一个空课程1==>",
        state.menusData.blocksSelected,
        state.menusData.blocksForm
      );
      const selectedNode = state.menusDataIds[state.menusData.blocksSelected]
      if (
        !selectedNode.children ||
        (selectedNode.children && selectedNode.children.length <= 0)
      ) {
        selectedNode.children = [data2];
      } else {
        // const div = document.querySelector('.lesson-box.deep-black .drop-box')
        // const height = div && div.clientHeight
        let index = 0;
        // 获取当前选中的索引
        if(selectedNode.children && selectedNode.children.length){
          selectedNode.children.map((v, i)=>{
            if(`${v.unique}` === `${state.menusData.lessonSelected}`){
              index = i+1
            }
          })
        }
        console.log('优化速度==>addOneMenuData')
        selectedNode.children.splice(index, 0, data2);
      }
      eventBus.$emit('onCurForm', selectedNode.children)
      console.log("添加一个空课程2==>", selectedNode, data2);

      // 刷新当前菜单children
      const newChildren = selectedNode.children.map(v=>{
        let obj = {...v}
        delete obj.config
        return obj
      })
      const curNode = curSelectedNode({})
      curNode.children = newChildren

      // debugger

      // let data = state.menusData
      // let arr = data.lessonSelected.split('/')
      // if (!data.blocksForm[data.blocksSelected].children || data.blocksForm[data.blocksSelected].children.length === 0){
      //   data.blocksForm[data.blocksSelected].children = [data2]
      // }else {
      //   data.lessonSelected = `${arr[0]}/${parseInt(arr[1]) + 1}`
      //   const arr2 =  data.blocksForm[data.blocksSelected].children
      //   arr2.splice(parseInt(arr[1])+1,0,data2)
      //   console.log('arr2==>', arr2, parseInt(arr[1])+1)
      // }
      // commit('addOneMenuData', data)

      // 向cocos侧通知 当前配置
      setTimeout(() => {
        try {
          let value = state.menusDataIds[data2.unique]
          state.menusData.lessonSelected = value.unique;
          state.menusData.lessonSelectedConfig = {type: value.type}
          postMessage({ type: "GetLessonConfig", value });
        } catch (e) {
          console.log("保存当前配置失败3==>", e);
        }
      });
    },
    setSaving({ commit }, data) {
      commit("setSaving", data);

      // 超过一分钟自动关闭
      // let fn = setTimeout(() => {
      //   if (state.saving) {
      //     commit("setSaving", false);
      //   }
      //   clearTimeout(fn);
      // }, 60 * 1000);
    },
    setDev({ commit }, data) {
      commit("setDev", data);
    },
    setUpdateState({ commit }, value) {
      commit("setUpdateState", value);
    },
    setNotice({ commit }, data) {
      commit("notice", data);
    },
    setIsBuilding({ commit }, data) {
      commit("setIsBuilding", data);
    },
    setGameConfig({ commit, state }, data) {
      console.log('设置游戏编辑开始==>')
      let obj = state.editGameConfig;
      // 如果权量存在，则开始执行
      if (data.timestamp) state.timestamp = data.timestamp;
      data.operationQueue &&
        data.operationQueue.map(v => {
          let path = v.basePath + v.path;
          switch (v.operation) {
            case "PUT":
              if (v.path === "/") {
                obj = v.data;
              } else {
                obj = putObject(obj, path, v.data);
              }
              break;
            case "DELETE":
              obj = deleteObject(obj, path);
              break;
            case "REPLACE":
              obj = putObject(obj, path, v.data);
              break;
            case "REFRESH":
              obj = putObject(obj, path, v.data);
              break;
            case "TRIGGER":
              break;
          }
        });
      commit("setGameConfig", obj);
      console.log('设置游戏编辑结束==>')
    },
    setCurClassType({ commit }, value) {
      commit("setCurClassType", value);
    },
    async cancelSelectMenu({ commit, state } , callback) {
      // 通知服务端 取消 当前课件/模版 插入ppt
      console.log("通知服务端 取消 当前课件/模版 插入ppt");
      const opted = await ResultServer.updatePPTStatus({
        clientsId: state.initConfig.school_id,
        resources_id: state.tempInsertPPTConfig.data.id,
        status: 4
      })
      callback && callback(opted)
      commit("cancelSelectMenu");
    },
    setGlobalSselectUnique({ commit }, value) {
      commit("setGlobalSselectUnique", value);
    },
    // 设置PPT历史记录
    setPPTData({ commit }, value) {
      commit("setPPTData", value);
    },
    // 设置插入PPT临时菜单配置信息
    setTempInsertPPTConfig({ commit }, value) {
      commit("setTempInsertPPTConfig", value);
    },
    // 设置插入PPT临时菜单配置信息
    setSendKeyBoardToCocos({ commit }, {key, value}) {
      commit("setSendKeyBoardToCocos", {key, value});
    },
    // 设置题库选中配置
    setQuestionBankConfig({ commit }, params) {
      commit("setQuestionBankConfig", params);
    },
    // 插入通知cocos事件队列
    setOperationQueue({ commit }, list){
      commit("setOperationQueue", list);
    },
    changeBrandName ({ commit }, id) {
      LoginServer.getLogo(id).then(res => {
        if (res.data) {
          commit('changeBrandName', res.data)
        } else {
          commit('changeBrandName', null)
        }
      })
    },
    setVipInfo({ commit },id) {
      LoginServer.getVipInfo(id).then(res => {
        commit('setVipInfo', res);
      })
    },
  },
  modules: {}
});
